import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import {
  buscarUnidad,
  listarCorrientesResiduales,
  listarPeligrosidades,
  listarTecnologiasTratamiento,
} from "../api/General";
import { isInvalid } from "../utils/forms";
import { crearResiduoPeligroso } from "../utils/data";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import TextField from "./controls/TextField";
import ArrayField from "./controls/ArrayField";
import { ResiduoPeligrosoForm } from "./ResiduoPeligrosoForm";
import { ResiduoPeligrosoList } from "./ResiduoPeligrosoList";
import { TipoTramite } from "../utils/enums";

export default function ResiduosPeligrososForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const { t } = useTranslation();
  const jurisdiccion =
    tramite.tipo?.codigo === TipoTramite.DJRR
      ? tramite.establecimiento?.domicilio?.provincia?.codigo
      : tramiteForm.values?.domicilio?.provincia?.codigo;
  const corrientesCatalog = useCatalog(
    jurisdiccion ? ["corrientesResiduales", jurisdiccion] : null,
    () => listarCorrientesResiduales({ jurisdiccion }),
  );
  const caracteristicasCatalog = useCatalog(
    ["peligrosidades"],
    () => listarPeligrosidades({}),
  );
  const unidadCantidadCatalog = useCatalog(["unidad", "KG"], () =>
    buscarUnidad("KG"),
  );
  const tecnologiasCatalog = useCatalog(
    ["tecnologiasTratamiento", "PELIGROSO"],
    () => listarTecnologiasTratamiento({ tipo: "PELIGROSO" }),
  );
  const corrientes = jurisdiccion ? corrientesCatalog.data || [] : [];
  const loading =
    corrientesCatalog.loading ||
    caracteristicasCatalog.loading ||
    unidadCantidadCatalog.loading ||
    tecnologiasCatalog.loading;
  const handleRegistroResiduosPeligrososChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleResiduosPeligrososChange = (event) => {
    tramiteForm.handleChange(event);
  };
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={4}>
            <TextField
              id="registroResiduosPeligrosos"
              name="registroResiduosPeligrosos"
              label={t("tramite.registroResiduosPeligrosos")}
              value={tramiteForm.values?.registroResiduosPeligrosos}
              onChange={handleRegistroResiduosPeligrososChange}
              labelStyle={{ whiteSpace: "nowrap" }}
              isInvalid={isInvalid("registroResiduosPeligrosos", tramiteForm)}
              error={t(tramiteForm.errors.registroResiduosPeligrosos)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ArrayField
              id="residuosPeligrosos"
              name="residuosPeligrosos"
              label={t("tramite.residuosPeligrosos")}
              value={tramiteForm.values?.residuosPeligrosos}
              onChange={handleResiduosPeligrososChange}
              createItem={crearResiduoPeligroso}
              isInvalid={isInvalid("residuosPeligrosos", tramiteForm)}
              error={
                (tramiteForm.errors.residuosPeligrosos instanceof Array &&
                  t("errors.tramite.residuosPeligrosos.many")) ||
                t(tramiteForm.errors.residuosPeligrosos)
              }
              disabled={!isEditable(tramite)}
            >
              {({
                value: residuosPeligrosos,
                append,
                remove,
                replace,
                select,
                selectedItem,
                selectedIndex,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <ResiduoPeligrosoForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={residuosPeligrosos.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          operacionesUnitarias={
                            tramiteForm.values.operacionesUnitarias
                          }
                          corrientes={corrientes}
                          caracteristicasPeligrosidad={caracteristicasCatalog.data}
                          tecnologias={tecnologiasCatalog.data}
                          unidadCantidad={unidadCantidadCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <ResiduoPeligrosoList
                        value={residuosPeligrosos}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
